import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

/*
 * Fires when the app receives the Video and starts playing it.
 */

// eslint-disable-next-line no-unused-vars
export const clickPauseBeacon = (action, prevState, nextState) => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.INTERACT,
  eventName: EVENT_NAMES.CLICK_PAUSE,
});
